import { ref, readonly } from 'vue'

export const useInternshipFeatures = (initial, master) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value.sort((a, b) => a - b)
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = []
  }

  return { features: readonly(state), master: readonly(master), set, reset, clear }
}